// InstallPWAButton.jsx
import React, { useEffect, useRef, useState } from "react";

const AddGameToinstall = ({ className = "", children = "Install App" }) => {
  const [visible, setVisible] = useState(false);
  const deferredPrompt = useRef(null);

  useEffect(() => {
    function onBeforeInstallPrompt(e) {
      e.preventDefault();
      deferredPrompt.current = e;
      setVisible(true); // show button
    }

    window.addEventListener("beforeinstallprompt", onBeforeInstallPrompt);

    return () => {
      window.removeEventListener("beforeinstallprompt", onBeforeInstallPrompt);
    };
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt.current) return;

    deferredPrompt.current.prompt();

    try {
      const choice = await deferredPrompt.current.userChoice;
      console.log("User choice:", choice.outcome);
    } catch (err) {
      console.error("Install prompt error:", err);
    }

    deferredPrompt.current = null;
    setVisible(false); // hide after prompt
  };

  if (!visible) return null; // don't render button at all when not visible

  return (
    <button
      type="button"
      onClick={handleInstallClick}
      className={`install-pwa-btn ${className}`}
      style={{ color: "red" }}
    >
      {children}
    </button>
  );
};
export default AddGameToinstall;
